module.exports = "/images/Russia.png?9deab5756253056d63233642297dba32";